var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.direction === 'right' ? 'slide-left' : _vm.direction === 'left' ? 'slide-right' : null}},[(_vm.isOpen)?_c('div',{ref:"sidebar",staticClass:"mw-100 fixed cl-accent bg-cl-primary",class:{
      'left-sidebar': _vm.direction === 'left',
      'right-sidebar': _vm.direction === 'right',
      'sidebar-microcart': _vm.isMicrocartOpen
    },attrs:{"data-testid":"sidebar"}},[_c(_vm.component,{tag:"component",on:{"close":function($event){return _vm.$emit('close')},"reload":_vm.getComponent}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }